import { defineMessages } from 'react-intl';

const messages = defineMessages({
  pageNotFoundTitle: {
    id: 'pageNotFound.pageNotFoundTitle',
    defaultMessage: 'Sorry, the page you’re looking for isn’t available',
    description: 'Title message on the page not found page',
  },
  pageNotFoundDescription: {
    id: 'pageNotFound.pageNotFoundDescription',
    defaultMessage:
      'The page you’re looking for might have been removed, had its name changed, or is temporarily unavailable.',
    description: 'Description message on the page not found page',
  },
  pageNotFoundWhatToDo: {
    id: 'pageNotFound.pageNotFoundWhatToDo',
    defaultMessage: 'What to do next:',
    description: 'What to do message on the page not found page',
  },
  pageNotFoundTodoStep1: {
    id: 'pageNotFound.pageNotFoundTodoStep1',
    defaultMessage: 'Refresh the page in a few minutes.',
    description: 'First step message on the page not found page',
  },
  pageNotFoundTodoStep2: {
    id: 'pageNotFound.pageNotFoundTodoStep2',
    defaultMessage: 'Check the URL for typos.',
    description: 'Second step message on the page not found page',
  },
  pageNotFoundTodoStep3: {
    id: 'pageNotFound.pageNotFoundTodoStep3',
    defaultMessage: 'Go back to the homepage or navigate to another section.',
    description: 'Third step message on the page not found page',
  },
  pageNotFoundRefreshButtonLabel: {
    id: 'pageNotFound.pageNotFoundRefreshButtonLabel',
    defaultMessage: 'Refresh Page',
    description: 'Label for the refresh button on the page not found page',
  },
  pageNotFoundReturnToHomeButtonLabel: {
    id: 'pageNotFound.pageNotFoundReturnToHomeButtonLabel',
    defaultMessage: 'Return to Home',
    description: 'Label for the return to homepage button on the page not found page',
  },
});

export default messages;
